<!--
OK
-->
<template>
  <div class="registrati">
    <br class="d-none d-md-block" />
    <div class="corpo-registrati">
      <NomeSito style="float: left" />
      <div style="float: right">
        <br />
        <Lingua></Lingua>
      </div>
      <div style="clear: both"></div>

      <b-row>
        <b-col cols="12" style="text-align: center">
          <p style="color: orange; font-size: 2.5em; font-weight: normal">
            {{ labels.registrati }}
          </p>
        </b-col>
      </b-row>

      <br />

      <p>
        {{ labels.benvenuto }}
        <b>{{ labels.label_partner }}.</b>
      </p>
      <p style="text-align: justify">
        {{ labels.se_viceversa }}
        <b>{{ labels.nuova_struttura }}</b>
        , {{ labels.e_necessario_accedere }}.
        <b-link v-on:click="VaiALogin">{{ labels.vai_a_login }}.</b-link>
      </p>
      <br />
      <b-form-row class="b-form-row">
        <b-col sm="12" md="12" lg="4" xl="4">
          <b-form-group v-bind:label="labels.partner">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="codice"
              v-model="codice"
              maxlength="45"
            ></b-form-input>
            <p class="errore" id="errore-partner" v-if="isError(errori.codice)">
              {{ labels_errori[errori.codice] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="12" lg="8" xl="8">
          <b-form-group v-bind:label="labels.descrizione_partner">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="descrizione"
              v-model="descrizione"
              maxlength="45"
            ></b-form-input>
            <p
              class="errore"
              id="errore-descrizione"
              v-if="isError(errori.descrizione)"
            >
              {{ labels_errori[errori.descrizione] }}
            </p>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row">
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-form-group class="b-form-group" v-bind:label="labels.password">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="password"
              v-model="password"
              maxlength="255"
              type="password"
              autocomplete="off"
            ></b-form-input>
            <p
              class="errore"
              id="errore-password"
              v-if="isError(errori.password)"
            >
              {{ labels_errori[errori.password] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-form-group
            class="b-form-group"
            v-bind:label="labels.conferma_password"
          >
            <b-form-input
              :size="size"
              class="b-form-input"
              id="conferma-password"
              v-model="conferma_password"
              maxlength="255"
              type="password"
              autocomplete="off"
            ></b-form-input>
            <p
              class="errore"
              id="errore-conferma-password"
              v-if="isError(errori.conferma_password)"
            >
              {{ labels_errori[errori.conferma_password] }}
            </p>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row">
        <b-col sm="12" md="12" lg="12" xl="12">
          <b-form-group class="b-form-group" v-bind:label="labels.email">
            <b-form-input
              :size="size"
              class="b-form-input"
              id="email"
              v-model="email"
              maxlength="255"
              type="text"
            ></b-form-input>
            <p class="errore" id="errore-email" v-if="isError(errori.email)">
              {{ labels_errori[errori.email] }}
            </p>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row
        class="b-form-row"
        style="text-align: center; color: orange; font-weight: bold"
      >
        <b-col sm="12" md="12" lg="12" xl="12">
          <p>{{ labels.prendere_nota_accuratamente }}</p>
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row">
        <b-col sm="12" md="12" lg="12" xl="12">
          <b-form-group class="b-form-group">
            <b-form-checkbox
              id="privact"
              v-model="privacy"
              name="privacy"
              value="S"
              unchecked-value
              ><i>
                {{ labels.acconsento_al_trattamento }}
                <b-link @click="VaiAPrivacy">{{
                  labels.leggi_informativa
                }}</b-link>
              </i></b-form-checkbox
            >
            <p
              class="errore"
              id="errore-privacy"
              v-if="isError(errori.privacy)"
            >
              {{ labels_errori[errori.privacy] }}
            </p>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row" style="text-align: center">
        <b-col sm="12" md="12" lg="12" xl="12">
          <b-button
            style="width: 100%"
            variant="success"
            @click="invia"
            :disabled="invio_in_corso"
            >{{ labels.invia }}</b-button
          >
          <div class="errore" id="errore-invia" v-if="isError(errori.invia)">
            <br />
            {{ labels_errori[errori.invia] }}
          </div>
        </b-col>
      </b-form-row>
    </div>

    <br class="d-none d-md-block" />
  </div>
</template>

<script>
import NomeSito from "@/components/NomeSito.vue";
import Lingua from "@/components/Lingua.vue";
import { utility } from "@/utility";
const axios = require("axios");

export default {
  name: "Registrati",
  components: {
    NomeSito,
    Lingua,
  },
  data() {
    return {
      labels: {},
      labels_errori: {},
      errori: {},
      codice: "",
      descrizione: "",
      email: "",
      password: "",
      conferma_password: "",
      size: "sm",
      invio_in_corso: false,
      privacy: "",
    };
  },
  mixins: [utility],
  methods: {
    invia() {
      try {
        if (!fn_ControllaDati(this)) {
          return;
        }

        let me = this;

        let parametri = {
          dati_partner: {
            codice: this.codice,
            descrizione: this.descrizione,
            password: this.password,
            email: this.email,
          },
        };
        let parametri_json = JSON.stringify(parametri);

        let ServerURL = this.$store.state.ServerURL;
        fn_CambiaCursore("wait", this);
        this.invio_in_corso = true;

        axios({
          method: "post",
          url: ServerURL + "CheckIn/RegistraPartner",
          data: parametri_json,
        })
          .then(function (response) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            if (response.data.errore == 0) {
              me.$router.push({
                name: "RegistrazioneInviata",
                params: {
                  codice: me.codice,
                  descrizione: me.descrizione,
                  indirizzo_email: me.email,
                },
              });
            } else if (response.data.errore == -2) {
              me.registraErrore(response.data.esito, "Registrati-invia");
              fn_CambiaCursore("default", me);
            } else {
              me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                title: me.labels_errori.si_e_verificato_un_errore,
                bodyClass: "errore",
              });
            }
          })
          .catch(function (error) {
            me.invio_in_corso = false;
            me.registraErrore(error, "Registrati-invia");
          });
      } catch (error) {
        this.invio_in_corso = false;
        this.registraErrore(error, "Registrati-invia");
      }
    },
    VaiALogin() {
      try {
        this.$router.push("/login");
      } catch (error) {
        this.registraErrore(error, "Registrati-VaiALogin");
      }
    },
    VaiAPrivacy() {
      let routeData = this.$router.resolve({
        name: "InformativaRegistrazionePartner",
      });
      window.open(routeData.href, "_blank");
    },
  },
  created() {
    try {
      fn_CambiaLingua(this.$store.state.Lingua, this);
    } catch (error) {
      this.registraErrore(error, "Registrati-created");
    }
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      registrati: "Registrati",
      benvenuto:
        "Benvenuto! Questo è un modulo per la registrazione di un nuovo",
      label_partner: "partner",
      se_viceversa: "Se, viceversa, si desidera registrare una",
      nuova_struttura: "nuova struttura per un partner già esistente",
      e_necessario_accedere:
        "è necessario accedere come utente partner ed utilizzare la funzione di Gestione Strutture",
      vai_a_login: "Vai a login",
      partner: "Codice partner",
      descrizione_partner: "Descrizione",
      email: "Email",
      password: "Password",
      conferma_password: "Conferma password",
      invia: "Invia",
      prendere_nota_accuratamente:
        "Prendere nota accuratamente di codice utente e password. Assicurarsi che l'indirizzo email sia valido e attivo.",
      acconsento_al_trattamento:
        "Acconsento al trattamento dei dati personali, per i fini del sito Facile Check-in",
      leggi_informativa: " (leggi l'informativa).",
    };
    let labels_inglese = {
      registrati: "Registrati",
      benvenuto:
        "Benvenuto! Questo è un modulo per la registrazione di un nuovo",
      label_partner: "partner",
      se_viceversa: "Se, viceversa, si desidera registrare una",
      nuova_struttura: "nuova struttura per un partner già esistente",
      e_necessario_accedere:
        "è necessario accedere come utente partner ed utilizzare la funzione di Gestione Strutture",
      vai_a_login: "Vai a login",
      partner: "Codice partner",
      descrizione_partner: "Descrizione",
      email: "Email",
      password: "Password",
      conferma_password: "Conferma password",
      invia: "Invia",
      prendere_nota_accuratamente:
        "Prendere nota accuratamente di codice utente e password. Assicurarsi che l'indirizzo email sia valido e attivo.",
      acconsento_al_trattamento:
        "Acconsento al trattamento dei dati personali, per i fini del sito Facile Check-in",
      leggi_informativa: "(leggi l'informativa).",
    };
    let labels_tedesco = {
      registrati: "Registrati",
      benvenuto:
        "Benvenuto! Questo è un modulo per la registrazione di un nuovo",
      label_partner: "partner",
      se_viceversa: "Se, viceversa, si desidera registrare una",
      nuova_struttura: "nuova struttura per un partner già esistente",
      e_necessario_accedere:
        "è necessario accedere come utente partner ed utilizzare la funzione di Gestione Strutture",
      vai_a_login: "Vai a login",
      partner: "Codice partner",
      descrizione_partner: "Descrizione",
      email: "Email",
      password: "Password",
      conferma_password: "Conferma password",
      invia: "Invia",
      prendere_nota_accuratamente:
        "Prendere nota accuratamente di codice utente e password. Assicurarsi che l'indirizzo email sia valido e attivo.",
      acconsento_al_trattamento:
        "Acconsento al trattamento dei dati personali, per i fini del sito Facile Check-in",
      leggi_informativa: "(leggi l'informativa).",
    };
    let labels_francese = {
      registrati: "Registrati",
      benvenuto:
        "Benvenuto! Questo è un modulo per la registrazione di un nuovo",
      label_partner: "partner",
      se_viceversa: "Se, viceversa, si desidera registrare una",
      nuova_struttura: "nuova struttura per un partner già esistente",
      e_necessario_accedere:
        "è necessario accedere come utente partner ed utilizzare la funzione di Gestione Strutture",
      vai_a_login: "Vai a login",
      partner: "Codice partner",
      descrizione_partner: "Descrizione",
      email: "Email",
      password: "Password",
      conferma_password: "Conferma password",
      invia: "Invia",
      prendere_nota_accuratamente:
        "Prendere nota accuratamente di codice utente e password. Assicurarsi che l'indirizzo email sia valido e attivo.",
      acconsento_al_trattamento:
        "Acconsento al trattamento dei dati personali, per i fini del sito Facile Check-in",
      leggi_informativa: "(leggi l'informativa).",
    };

    let labels_errori_italiano = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      password_non_corrispondenti: "Password non corrispondenti",
      partner_gia_esistente: "Partner già esistente",
      privacy_obbligatoria:
        "Il consenso alla privacy è obbligatorio per poter proseguire",
      registrazione_non_completata:
        "Un utente con lo stesso codice esiste già ma la sua registrazione non è stata ancora completata. Per completare la registrazione, utilizzare l'email ricevuta al momento della registrazione. Altrimenti, allo scadere delle 48 ore, il codice sarà nuovamente disponibile. ",
    };
    let labels_errori_inglese = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      password_non_corrispondenti: "Password non corrispondenti",
      partner_gia_esistente: "Partner già esistente",
      privacy_obbligatoria:
        "Il consenso alla privacy è obbligatorio per poter proseguire",
      registrazione_non_completata:
        "Un utente con lo stesso codice esiste già ma la sua registrazione non è stata ancora completata. Per completare la registrazione, utilizzare l'email ricevuta al momento della registrazione. Altrimenti, allo scadere delle 48 ore, il codice sarà nuovamente disponibile. ",
    };
    let labels_errori_tedesco = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      password_non_corrispondenti: "Password non corrispondenti",
      partner_gia_esistente: "Partner già esistente",
      privacy_obbligatoria:
        "Il consenso alla privacy è obbligatorio per poter proseguire",
      registrazione_non_completata:
        "Un utente con lo stesso codice esiste già ma la sua registrazione non è stata ancora completata. Per completare la registrazione, utilizzare l'email ricevuta al momento della registrazione. Altrimenti, allo scadere delle 48 ore, il codice sarà nuovamente disponibile. ",
    };
    let labels_errori_francese = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      password_non_corrispondenti: "Password non corrispondenti",
      partner_gia_esistente: "Partner già esistente",
      privacy_obbligatoria:
        "Il consenso alla privacy è obbligatorio per poter proseguire",
      registrazione_non_completata:
        "Un utente con lo stesso codice esiste già ma la sua registrazione non è stata ancora completata. Per completare la registrazione, utilizzare l'email ricevuta al momento della registrazione. Altrimenti, allo scadere delle 48 ore, il codice sarà nuovamente disponibile. ",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "Registrati-fn_CambiaLingua");
  }
}

function fn_ControllaDati(vm) {
  try {
    let esito = true;

    vm.errori = {};
    if (vm.codice.trim() == "") {
      vm.errori.codice = "dato_obbligatorio";
      esito = false;
    }
    if (vm.descrizione.trim() == "") {
      vm.errori.descrizione = "dato_obbligatorio";
      esito = false;
    }
    if (vm.password.trim() == "") {
      vm.errori.password = "dato_obbligatorio";
      esito = false;
    } else {
      if (vm.password != vm.conferma_password) {
        vm.errori.password = "password_non_corrispondenti";
        esito = false;
      }
    }

    if (vm.email.trim() == "") {
      vm.errori.email = "dato_obbligatorio";
      esito = false;
    } else {
      let pattern = vm.$store.state.PatternEmail;
      if (!pattern.test(vm.email)) {
        vm.errori.email = "indirizzo_email_non_valido";
        esito = false;
      }
    }

    if (vm.privacy != "S") {
      vm.errori.privacy = "privacy_obbligatoria";
      esito = false;
    }

    if (esito) {
      return true;
    } else {
      vm.errori.invia = "si_sono_verificati_degli_errori";
      return false;
    }
  } catch (error) {
    vm.registraErrore(error, "Registrati-fn_ControllaDati");
  }
}

function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}
</script>

<style scoped>
.registrati {
  text-align: center;
  width: 580px;
  margin: auto;
}
.corpo-registrati {
  text-align: left;
  padding: 20px 40px 30px 40px;
  background-color: #f7f7f7;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

.b-form-group {
  text-align: left;
}
</style>
